import { createFileRoute } from '@tanstack/react-router';
import { OnboardingGrid } from '../../../onboarding/components/grid/onboarding-grid.tsx';
import { CustomerScopeGate } from '../../../deployment/admin-scope.tsx';

export const Route = createFileRoute('/onboarding/')({
  component: OnboardingPage,
});

function OnboardingPage(): JSX.Element {
  return (
    <CustomerScopeGate>
      {(customerId) => <OnboardingGrid customerId={customerId} />}
    </CustomerScopeGate>
  );
}
